import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum OptionsType {
	NONE = "none",
	CUSTOM = "custom",
	DATE = "date",
	PAGE = "page",
	BATES = "bates"
}

export enum OptionsTypeDate {
	"M/D" = "m/d",
	"M/D/YY" = "m/d/yy",
	"M/D/YYYY" = "m/d/yyyy",
	"MM/DD/YY" = "mm/dd/yy",
	"MM/DD/YYYY" = "mm/dd/yyyy",
	"D/M/YY" = "d/m/yy",
	"D/M/YYYY" = "d/m/yyyy",
	"DD/MM/YY" = "dd/mm/yy",
	"DD/MM/YYYY" = "dd/mm/yyyy",
	"MM/YY" = "mm/yy",
	"MM/YYYY" = "mm/yyyy",
	"M.D" = "m.d",
	"M.D.YY" = "m.d.yy",
	"M.D.YYYY" = "m.d.yyyy",
	"MM.DD.YY" = "mm.dd.yy",
	"MM.DD.YYYY" = "mm.dd.yyyy",
	"D.M.YY" = "d.m.yy",
	"D.M.YYYY" = "d.m.yyyy",
	"DD.MM.YY" = "dd.mm.yy",
	"DD.MM.YYYY" = "dd.mm.yyyy",
	"MM.YY" = "mm.yy",
	"MM.YYYY" = "mm.yyyy"
}

export enum OptionsTypePage {
	"I" = "i",
	"I_/_N" = "i / n",
	"I_OF_N" = "i of n",
	"PAGE_I" = "page i",
	"PAGE_I_OF_N" = "page i of n",
}

export class HeaderFooterOptions implements Parameter {
	public type?: OptionsType;
	public date?: OptionsTypeDate;
	public page?: OptionsTypePage;
	public batesPrefix?: string;
	public batesSuffix?: string;
	public batesDigits?: number;
	public custom?: string;

	constructor(data: any) {
		this.type = FunctionHelper.exists(data?.type) ? data.type : OptionsType.NONE;
		this.date = FunctionHelper.exists(data?.date) ? data.date : OptionsTypeDate["M/D"];
		this.page = FunctionHelper.exists(data?.page) ? data.page : OptionsTypePage.I;
		this.batesPrefix = FunctionHelper.exists(data?.batesPrefix) ? data.batesPrefix : "";
		this.batesSuffix = FunctionHelper.exists(data?.batesSuffix) ? data.batesSuffix : "";
		this.batesDigits = FunctionHelper.exists(data?.batesDigits) ? data.batesDigits : 6;
		this.custom = data.custom;
	}

	public static getTypeDefault(): OptionsType {
		return OptionsType.NONE;
	}

	public static getDateDefault(): OptionsTypeDate {
		return OptionsTypeDate["M/D"];
	}

	public static getPageDefault(): OptionsTypePage {
		return OptionsTypePage.I;
	}

	public static getBatesPrefixDefault(): string {
		return "";
	}

	public static getBatesSuffixDefault(): string {
		return "";
	}

	public static getBatesDigitsDefault(): number {
		return 6;
	}

	public static getBatesDigitsMin(): number {
		return 1;
	}

	public static getCustomDefault(): string {
		return "";
	}

	public static fromJson(data: any): HeaderFooterOptions {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new HeaderFooterOptions(data);
	}

	public toJson(): any {
		return {
			'type': this.type,
			'date': this.date,
			'page': this.page,
			'batesPrefix': this.batesPrefix,
			'batesSuffix': this.batesSuffix,
			'batesDigits': this.batesDigits,
			'custom': this.custom,
		};
	}

	public clone(): HeaderFooterOptions {
		return HeaderFooterOptions.fromJson(this.toJson());
	}

	/**
	 * Compute content string values from parameter objects
	 */
	public computeContents(firstPageNumber: number): string {
		switch (this.type) {
			case OptionsType.CUSTOM:
				return FunctionHelper.applyValue(this.custom, "");
			case OptionsType.DATE:
				return "<<" + this.date + ">>";
			case OptionsType.PAGE:
				return "<<" + this.page + ">>";
			case OptionsType.BATES:
				return "<<#" + this.batesDigits + "#" + firstPageNumber + "#" + this.batesPrefix + "#" + this.batesSuffix + ">>";
			case OptionsType.NONE:
			default:
				return "";
		}
	}
}